import { Link } from 'react-router-dom';
import { Calendar, Users, ArrowRight } from 'lucide-react';
import { useAuthStore } from '../../store/auth';

export function BookPage() {
  const { isAuthenticated } = useAuthStore();

  return (
    <div className="py-12">
      <div className="max-w-3xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Book Track Time</h1>
          <p className="text-xl text-gray-600">
            Reserve exclusive access to our world-class facilities
          </p>
        </div>

        {isAuthenticated ? (
          <div className="card p-8">
            <h2 className="text-2xl font-bold mb-6">Create a Booking</h2>
            <p className="text-gray-600 mb-8">
              Select a team to book track time. Only team admins and managers can
              create bookings.
            </p>

            <Link
              to="/dashboard"
              className="btn btn-primary btn-lg w-full justify-center"
            >
              Go to Dashboard
              <ArrowRight size={20} className="ml-2" />
            </Link>
          </div>
        ) : (
          <div className="space-y-8">
            {/* Login/Register CTA */}
            <div className="card p-8 text-center">
              <h2 className="text-2xl font-bold mb-4">Get Started</h2>
              <p className="text-gray-600 mb-6">
                Create an account or sign in to book track time
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/register"
                  className="btn btn-primary btn-lg"
                >
                  <Users size={20} className="mr-2" />
                  Create Account
                </Link>
                <Link
                  to="/login"
                  className="btn btn-outline btn-lg"
                >
                  Sign In
                </Link>
              </div>
            </div>

            {/* How it works */}
            <div className="card p-8">
              <h2 className="text-2xl font-bold mb-6">How Booking Works</h2>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-red-600 font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Create Your Team</h3>
                    <p className="text-gray-600">
                      Register an account and create your racing team. Add team
                      members with different roles.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-red-600 font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Browse Availability</h3>
                    <p className="text-gray-600">
                      Check the calendar to see available time slots across our
                      different tracks.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-red-600 font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Submit a Request</h3>
                    <p className="text-gray-600">
                      Select your preferred track and time slot, then submit a
                      booking request.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-red-600 font-bold">4</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Get Confirmation</h3>
                    <p className="text-gray-600">
                      Our team will review your request and send you a
                      confirmation with payment details.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing Info */}
            <div className="bg-gray-50 rounded-xl p-8">
              <h2 className="text-xl font-bold mb-4">Track Pricing</h2>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Main Circuit</span>
                  <span className="font-semibold">$4,500/slot</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Drag Strip</span>
                  <span className="font-semibold">$3,200/slot</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">Skid Pan</span>
                  <span className="font-semibold">$1,800/slot</span>
                </div>
              </div>
              <p className="text-sm text-gray-500 mt-4">
                * Prices include exclusive track access, marshals, and basic facilities
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
